<template>
	<div class="BaseAccountUserDetailsTable">
		<!-- <div class="table-sns">
      <h3>
        Upload Stock Count
      </h3>
      <a
        class="cursor-pointer"
      >
        Export Count
      </a>
    </div> -->
		<el-row>
			<el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="24">
				<div
					v-if="isAddMoreButton"
					class="my-4  text-center flex justify-around"
				>
					<span class="text-sm font-bold mr-2 mt-2" style="color: #606266"
						>Add User</span
					>
					<div class="w-16">
						<BaseButton
							buttonclass="btn text-sm py-2"
							@click="addNewAccountUser"
						>
							Add
						</BaseButton>
					</div>
				</div>
			</el-col>
		</el-row>

		<simplebar v-if="accountUsers.length" class="simplebar">
			<table class="tableMain">
				<thead>
					<tr>
						<th
							v-if="type === 'edit' && deleteUsers"
							colspan="1"
						
						>
							Delete Users
						</th>
						<th colspan="1">
							Full Name
						</th>
						<th colspan="1">
							Designation
						</th>
						<th colspan="1">
							Email Id
						</th>
						<th colspan="1">
							Mobile No
						</th>
						<th colspan="1">
							Access Level
						</th>
						<th colspan="1">
							Region
						</th>
						<th colspan="1">
							Sub Region
						</th>
						<th v-if="isAccountEdit" colspan="1">
							Status
						</th>
						<th colspan="1">
							<!-- Action -->
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(user, index) in accountUsers" :key="user.id">
						<td v-if="type === 'edit' && deleteUsers">
							<el-checkbox
								v-model="user.deleteUser"
								true-label="true"
								@change="removeUserFn(user.email)"
							></el-checkbox>
							<!-- <el-switch
								v-model="user.deleteUser"
								active-color="#ff4949"
								inactive-color="#13ce66"
							/> -->
						</td>
						<td>{{ user.full_name }}</td>
						<td>
							<!-- {{ user.designation_info ? user.designation_info.name : "-"}} -->

              <div
                v-if="
                  user.designation_info &&
                  check_present_designation_list.includes(
                    user.designation_info.id
                  )
                "
              >
                {{ user.designation_info.name }}
              </div>
              <div v-else>-</div>
						</td>
						<td>
							{{ user.email }}
						</td>
						<td>
							{{ user.contactNumber }}
						</td>
						<!-- <td>{{ user.access_level }}</td> -->
						<td>
							<span
								v-if="user.access_level"
								v-for="(permision, PerIndex) in userPermision"
								:key="PerIndex"
							>
								<span v-if="user.access_level == permision.id">
									{{ permision.name }}
								</span>
							</span>
						</td>
						<td>
							<span
								v-for="(region, reIndex) in regions"
								v-if="user.access_region"
								:key="reIndex"
							>
								<span v-if="user.access_region == region.id">
									{{ region.name }}
								</span>
							</span>
						</td>
						<td>
							<span
								v-for="(subregion, subreIndex) in subRegions"
								v-if="user.access_subregion"
								:key="subreIndex"
							>
								<span v-if="user.access_subregion == subregion.id">
									{{ subregion.name }}
								</span>
							</span>
						</td>
						<td v-if="isAccountEdit">
							<!-- <BaseButton buttonclass="btn py-1.5 px-4 text-sm">
							</BaseButton> -->
							<p>{{ user.status ? user.status : "-" }}</p>
						</td>
						<td>
							<div class="flex w-9/12 justify-around items-center text-center">
								<!-- <BaseButton
									buttonclass="btn py-1.5 px-4 text-sm"
									@click="
										accountUsers.length > 1 ? accountUsers.splice(index, 1) : ''
									"
								>
								del
								</BaseButton> -->
								<!-- v-if="type !== 'add'" -->
								<img
									class="cursor-pointer"
									width="27px"
									height="auto"
									src="../../assets/images/edit.png"
									alt=""
									@click="$emit('openEditBaseAccountUserPopup', user, index)"
								/>
								<img
									class="cursor-pointer"
									src="../../assets/images/delete-icon.png"
									alt=""
									@click="accountUsers.splice(index, 1)"
								/>
								<!-- @click="
										accountUsers.length > 1 ? accountUsers.splice(index, 1) : ''
									" -->
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</simplebar>
		<el-row>
			<el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
				<div
					v-if="!accountUsers.length"
					class="text-xs text-center p-10"
					style="color:#e29d5a"
				>
					There are currently no users added in this account type
				</div>
			</el-col>
		</el-row>
		<!-- <div class="">
			<el-row>
				<el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
					<el-row gutter="30">
						<el-col :xl="4" :lg="8" :md="8" :sm="8" :xs="24">
							<div
								v-if="isAddMoreButton"
								class="mt-4 text-center"
								style="display:flex;width: 200px;
								justify-content:space-between;"
							>
								<BaseButton
									v-if="!deleteUsers"
									class="w-20"
									buttonclass="btn py-1.5 px-4 text-sm"
									@click="accountUsers.push(addNewUser())"
								>
									Add More
								</BaseButton>

								<BaseButton
									v-if="deleteUsers"
									buttonclass="btn py-1.5 px-4 text-sm"
									@click="$emit('deleteUsersEvent', deleteUsersList)"
								>
									Delete
								</BaseButton>
							</div>
						</el-col>
						<el-col
							v-if="type === 'edit'"
							:xl="4"
							:lg="8"
							:md="8"
							:sm="8"
							:xs="24"
						>
							<div v-if="isAddMoreButton" class="mt-4 text-center">
								<BaseButton
									v-if="!deleteUsers"
									buttonclass="btn py-1.5 px-4 text-sm"
									@click="deleteUserFn"
								>
									Delete Users
								</BaseButton>
							</div>
						</el-col>
					</el-row>
				</el-col>
				<el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="24">
					<div class="flex md:justify-end align-start md:flex-row flex-col">
						<BaseButton
							v-if="!isAccountEdit"  
							class="mr-8 mt-4"
							buttonclass="btn py-1.5 px-4 text-sm"
							@click="$emit('addAccount', accountUsers, 'addAnother')"
						>
							Save & add Another
						</BaseButton>
						<BaseButton
							v-if="!isAccountEdit"
							class="mt-4"
							buttonclass="btn py-1.5 px-4 text-sm"
							@click="$emit('addAccount', accountUsers, 'continue')"
						>
							Save & continue
						</BaseButton>
						<BaseButton
							v-if="isAccountEdit && !deleteUsers"
							class="mr-8  mt-4"
							buttonclass="btn py-1.5 px-4 text-sm"
							@click="$emit('editAccount', accountUsers, 'update')"
						>
							Update
						</BaseButton>
						<div v-if="type === 'edit'" class="mt-4">
							<el-pagination
								background
								:page-sizes="[5, 10, 15]"
								layout="sizes, prev, pager, next"
							/>
						</div>
					</div>
				</el-col>
			</el-row>
		</div> -->
		<el-row>
			<el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
				<el-row>
					<!-- <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="24">
						<div
							v-if="isAddMoreButton"
							class="mt-4 text-center flex justify-around"
						>
							<span class="text-sm font-bold mr-2 mt-2" style="color: #606266"
								>Add User</span
							>
							<div class="w-16">
								<BaseButton
									buttonclass="btn text-sm py-2"
									@click="addNewAccountUser"
								>
									+
								</BaseButton>
							</div>
						</div>
					</el-col> -->
					<!-- <el-col :xl="7" :lg="7" :md="7" :sm="7" :xs="24">
						<div v-if="isAddMoreButton" class="mt-4 text-center">
							<BaseButton
								v-if="type === 'edit' && !deleteUsers"
								buttonclass="btn py-1.5 px-4 text-sm mx-2"
								@click="deleteUserFn"
							>
								Delete Users
							</BaseButton>
							<BaseButton
								v-if="deleteUsers"
								buttonclass="btn py-1.5 px-4 text-sm mx-2"
								@click="$emit('deleteUsersEvent', deleteUsersList)"
							>
								Delete
							</BaseButton>
						</div>
					</el-col> -->
					<el-col :xl="6" :lg="6" :md="6" :sm="6" :xs="24">
						<div class="mt-4 text-center">
							<BaseButton
								v-if="deleteUsers"
								buttonclass="btn py-1.5 px-4 text-sm mx-4"
								@click="cncleUserfn"
							>
								Cancel
							</BaseButton>
						</div>
					</el-col>
				</el-row>
			</el-col>

			<!-- <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
				<div class="text-xs text-center p-10" style="color:#e29d5a" v-if="!accountUsers.length">
					There are currently no users added in this account type
				</div>
			</el-col> -->

			<el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
				<div class="flex md:justify-end align-start md:flex-row flex-col">
					<BaseButton
						v-if="!isAccountEdit"
						class="mr-8 mt-4"
						buttonclass="btn py-1.5 px-4 text-sm"
						@click="$emit('addAccount', accountUsers, 'addAnother')"
					>
						Add More
					</BaseButton>
					<BaseButton
						v-if="!isAccountEdit"
						class="mt-4"
						buttonclass="btn py-1.5 px-4 text-sm"
						@click="$emit('addAccount', accountUsers, 'continue')"
					>
						Continue
					</BaseButton>
					<BaseButton
						v-if="isAccountEdit"
						class="mr-8  mt-4 w-48"
						:disabled="deleteUsers"
						buttonclass="btn py-1.5 px-4 text-sm"
						@click="$emit('editAccount', accountUsers, 'update')"
					>
						Update
					</BaseButton>
					<div v-if="type" class="mt-4">
						<el-pagination
							background
							:page-sizes="[5, 10, 15]"
							layout="sizes, prev, pager, next"
						/>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-dialog
			:key="addBaseAccountUserPopupKey"
			title="Add User"
			:visible.sync="showAddBaseAccountUserPopup"
			width="60%"
		>
			<BaseAccountUserDetailsPopup
				:account-type="type"
				:account-id="accountId"
				:new-account-user-data="newAccountUserData"
				:account-user-index="accountUsers.length"
				:regions="regions"
				:sub-regions="subRegions"
				:check-popup="checkPopup"
				@closeAddBaseAccountUserPopup="closePopup"
			/>
		</el-dialog>
	</div>
</template>

<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import userAccountsService from "../../services/userAccountsService";
import { mapState } from "vuex";
import { EventBus } from "../../eventBus";
import { serverAddr } from "../../networkConfig";

export default {
	name: "BaseAccountUserDetailsTable",
	components: {
		simplebar
	},
	inject: ["$validator"],
	props: {
		isAddMoreButton: {
			type: Boolean,
			default: false
		},
		isAccountEdit: {
			type: Boolean,
			default: false
		},
		accountUsers: {
			type: Array,
			required: true
		},
		type: {
			type: String,
			required: true
		},
		regions: {
			type: Array,
			default: () => []
		},
		subRegions: {
			type: Array,
			default: () => []
		},
		checkPopup: {
			type: String,
			default: () => ""
		},
		accountId: {
			type: String,
			default: () => ""
		}
	},
	data() {
		return {
			// deleteUsers: true,
			// addMoreBtnDisable: true,
			deleteUsersList: [],
			id: 1,
			showAddBaseAccountUserPopup: false,
			newAccountUserData: {
				deleteUser: false,
				firstName: "",
				lastName: "",
				designation: "",
				designation_info:{},
				email: "",
				contactNumber: "",
				status: ""
			},
			employeeIndex: null,
			addBaseAccountUserPopupKey: 0,
			userPermision: [
				{
					id: "outlet",
					name: "Store User"
				},
				{
					id: "region",
					name: "Regional User"
				},
				{
					id: "sub_region",
					name: "Sub Regional User"
				},
				{
					id: "super",
					name: "Super"
				},
				{
					id: "vendor",
					name: "Vendor"
				},
				{
					id: "employee",
					name: "Staff"
				},
				{
					id: "admin",
					name: "Admin"
				}
			],
      check_present_designation_list: [],
		};
	},

	computed: {
		...mapState("AccountsStore", ["deleteUsersStore"]),
		deleteUsers: {
			set(value) {
				this.$store.commit("AccountsStore/DELETE_USERS", value);
			},
			get(value) {
				return this.deleteUsersStore;
			}
		}
	},
	mounted() {
		EventBus.$on("updatedAccountUserData", this.updatedAccountUserData);
		EventBus.$on("saveNewAccountUserData", this.saveNewAccountUserData);
    EventBus.$on("updateDesignationList", this.updateDesignationList);
    this.getDesignationList();
	},
	beforeDestroy() {
		EventBus.$off("updatedAccountUserData");
		EventBus.$off("saveNewAccountUserData");
    EventBus.$off("updateDesignationList");
		this.$store.commit("AccountsStore/DELETE_USERS", false);
	},

	methods: {
    getDesignationList() {
      serverAddr
        .post(`/users/designations/list/`)
        .then((res) => {
          let response = JSON.parse(res.data);
          this.check_present_designation_list = [];
          response.forEach((element) => {
            this.check_present_designation_list.push(element.id);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateDesignationList() {
      this.getDesignationList();
    },
		closePopup() {
			this.showAddBaseAccountUserPopup = false;
		},
		addNewUser() {
			this.id += 1;
			return {
				deleteUser: false,
				firstName: "",
				lastName: "",
				designation: "",
				designation_info:{},
				email: "",
				contactNumber: "",
				status: "",
				id: this.id
			};
		},

		removeUserFn(email, actions) {
			// console.log("email", email, actions);
			var showDeleteIcon = false;
			this.accountUsers.map(user => {
				if (user.deleteUser) {
					showDeleteIcon = true;
				}
			});

			this.$store.commit("AccountsStore/DELETE_USERS", showDeleteIcon);


			if (this.deleteUsersList.indexOf(email) === -1 && email !== "") {
				this.deleteUsersList.push(email);
			} else {
				this.deleteUsersList = this.deleteUsersList.filter(
					userEmail => userEmail !== email
				);
			}
		},
		deleteUserFn() {
			// console.log("ankush", value);
			// if (!value) {
			// 	this.deleteUsersList = [];
			// 	// this.deleteUsers = false;
			// 	this.$store.commit("AccountsStore/DELETE_USERS", false);
			// 	this.deleteUsersList = [];
			// 	this.accountUsers.map(user => {
			// 		user.deleteUser = false;
			// 	});
			// }
			this.$store.commit("AccountsStore/DELETE_USERS", true);
			// this.isAccountEdit = false;
			// this.addMoreBtnDisable = false;
		},
		cncleUserfn() {
			this.$store.commit("AccountsStore/DELETE_USERS", false);
			this.accountUsers.forEach(user => {
				user.deleteUser = false;
			});
		},
		addNewAccountUser() {
			this.addBaseAccountUserPopupKey += 1; //You take this strategy of assigning keys to children, but whenever you want to re-render a component, you just update the key.
			this.showAddBaseAccountUserPopup = true;
			this.newAccountUserData = {
				firstName: "",
				lastName: "",
				designation: "",
				email: "",
				contactNumber: "",
				status: ""
			};
			this.$emit("changePopupValue");
		},
		updatedAccountUserData(accountUserDetails, accountUserIndex) {
			this.$set(this.accountUsers, [accountUserIndex], accountUserDetails);
		},
		saveNewAccountUserData(accountUserDetails, accountUserIndex) {
			if (accountUserIndex) {
				this.$set(this.accountUsers, [accountUserIndex], accountUserDetails);
			} else {
				this.accountUsers.push(accountUserDetails);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./BaseAccountUserDetailsTable.scss";
</style>

<style lang="scss">
.AppLayout .el-select .el-input.is-focus .el-input__inner {
	overflow: scroll;
}
</style>
